import { Record } from "../fable_modules/fable-library.3.7.20/Types.js";
import { option_type, equals, record_type, string_type } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import { ValidatedUrlModule_value as ValidatedUrlModule_value_1, UrlKind, ValidatedUrlModule_create } from "../HttpV2.js";
import { singleton } from "../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../fable_modules/fable-library.3.7.20/Choice.js";
import { map, bind, defaultArg } from "../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { SessionContext, RoleItem, SubItem, MenuItem, SessionContextDTO$reflection } from "../CommonTypes.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { compare, uncurry } from "../fable_modules/fable-library.3.7.20/Util.js";
import { getCsrfEnabledRequest, ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../HttpV2.js";
import { Http_content, Http_request, Http_method, Http_withCredentials, Http_send } from "../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { BodyContent, HttpMethod } from "../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { toFail, printf, toText } from "../fable_modules/fable-library.3.7.20/String.js";
import { SimpleJson_tryParse } from "../fable_modules/Fable.SimpleJson.3.21.0/SimpleJson.fs.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { createThunk } from "../Redux/Redux.js";
import { GlobalDependencies, $007CPrefix$007C_$007C, LoadState$2, LoadState_zip } from "../Global.js";
import { setSessionContext, setGlobalDependencies, setCountryTranslations, setTranslations } from "../Redux/Reducers/ModelReducer.js";
import { startImmediate } from "../fable_modules/fable-library.3.7.20/Async.js";
import { logei, optToStr, loge } from "../Utils.js";
import { sortBy, map as map_1 } from "../fable_modules/fable-library.3.7.20/List.js";

export class LogErrorDTO extends Record {
    constructor(Message, Stack, Url) {
        super();
        this.Message = Message;
        this.Stack = Stack;
        this.Url = Url;
    }
}

export function LogErrorDTO$reflection() {
    return record_type("Api.Global.LogErrorDTO", [], LogErrorDTO, () => [["Message", string_type], ["Stack", string_type], ["Url", string_type]]);
}

export function loadSessionContext() {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, "/SessionContext/"));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1) => {
            const str = arg_1;
            return equals(SessionContextDTO$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(SessionContextDTO$reflection(), arg, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(SessionContextDTO$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function loadTranslations(chosenLanguageCode, ugLanguageCode) {
    let url;
    const clo = toText(printf("/translations/%s"));
    url = (clo);
    const matchValue = [ValidatedUrlModule_create(new UrlKind(0, url(chosenLanguageCode))), ValidatedUrlModule_create(new UrlKind(0, url(ugLanguageCode)))];
    let pattern_matching_result, validChosenLanguageUrl, validUgLanguageUrl, msg_1;
    const copyOfStruct = matchValue[0];
    if (copyOfStruct.tag === 1) {
        pattern_matching_result = 1;
        msg_1 = copyOfStruct.fields[0];
    }
    else {
        const copyOfStruct_1 = matchValue[1];
        if (copyOfStruct_1.tag === 1) {
            pattern_matching_result = 1;
            msg_1 = copyOfStruct_1.fields[0];
        }
        else {
            pattern_matching_result = 0;
            validChosenLanguageUrl = copyOfStruct.fields[0];
            validUgLanguageUrl = copyOfStruct_1.fields[0];
        }
    }
    switch (pattern_matching_result) {
        case 0: {
            return singleton.Delay(() => singleton.Bind(Http_send(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value_1(validChosenLanguageUrl))))), (_arg) => {
                const chosenLanguageResponse = _arg;
                return singleton.Bind((chosenLanguageCode === ugLanguageCode) ? singleton.Return(chosenLanguageResponse) : Http_send(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value_1(validUgLanguageUrl))))), (_arg_1) => {
                    let matchValue_3, copyOfStruct_2, copyOfStruct_3;
                    const ugLanguageResponse = _arg_1;
                    const matchValue_2 = [chosenLanguageResponse.statusCode, ugLanguageResponse.statusCode];
                    if (matchValue_2[0] === 200) {
                        if (matchValue_2[1] === 200) {
                            const getDictResult = (jsonStr) => {
                                let _arg_2, dict;
                                return new FSharpResult$2(0, (_arg_2 = SimpleJson_tryParse(jsonStr), (_arg_2 != null) ? ((_arg_2.tag === 5) ? ((dict = _arg_2.fields[0], dict)) : (void 0)) : (void 0)));
                            };
                            const chosenLanguageDictResult = getDictResult(chosenLanguageResponse.responseText);
                            const ugLanguageDictResult = getDictResult(ugLanguageResponse.responseText);
                            return singleton.Return((matchValue_3 = [chosenLanguageDictResult, ugLanguageDictResult], (copyOfStruct_2 = matchValue_3[0], (copyOfStruct_2.tag === 1) ? (new FSharpResult$2(1, copyOfStruct_2.fields[0])) : ((copyOfStruct_3 = matchValue_3[1], (copyOfStruct_3.tag === 1) ? (new FSharpResult$2(1, copyOfStruct_3.fields[0])) : (new FSharpResult$2(0, [copyOfStruct_2.fields[0], copyOfStruct_3.fields[0]])))))));
                        }
                        else {
                            return singleton.Return(new FSharpResult$2(1, ugLanguageResponse.responseText));
                        }
                    }
                    else {
                        return (matchValue_2[1] === 200) ? singleton.Return(new FSharpResult$2(1, chosenLanguageResponse.responseText)) : singleton.Return(new FSharpResult$2(1, ugLanguageResponse.responseText + chosenLanguageResponse.responseText));
                    }
                });
            }));
        }
        case 1: {
            return singleton.Delay(() => singleton.Return(new FSharpResult$2(1, msg_1)));
        }
    }
}

export function logError(clientNr, dto) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/LogError/%i"))(clientNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(string_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(string_type, arg_1, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(LogErrorDTO$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(dto));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

export function loadTranslationsThunk(chosenLanguageCode, ugLanguageCode) {
    return createThunk((dispatch) => ((getState) => {
        if (LoadState_zip(getState().Model.Translations, getState().Model.CountryTranslations).tag === 1) {
        }
        else {
            if (getState().Model.Translations.tag === 2) {
            }
            else {
                dispatch(setTranslations(new LoadState$2(1)));
            }
            if (getState().Model.CountryTranslations.tag === 2) {
            }
            else {
                dispatch(setCountryTranslations(new LoadState$2(1)));
            }
            startImmediate(singleton.Delay(() => singleton.Bind(loadTranslations(chosenLanguageCode, ugLanguageCode), (_arg) => {
                const result = _arg;
                if (result.tag === 0) {
                    const matchValue_3 = bind((x1) => map((y) => [x1, y], result.fields[0][1]), result.fields[0][0]);
                    if (matchValue_3 != null) {
                        const ugDict = matchValue_3[1];
                        dispatch(setTranslations(new LoadState$2(2, matchValue_3[0])));
                        dispatch(setCountryTranslations(new LoadState$2(2, ugDict)));
                        return singleton.Zero();
                    }
                    else {
                        loge("Could not parse translations into dict.");
                        return singleton.Zero();
                    }
                }
                else {
                    loge("Could not parse translations into dict.");
                    const f = new LoadState$2(3, result.fields[0]);
                    dispatch(setTranslations(f));
                    dispatch(setCountryTranslations(f));
                    return singleton.Zero();
                }
            })));
        }
    }));
}

function iframeUrlToHash(str_mut) {
    iframeUrlToHash:
    while (true) {
        const str = str_mut;
        const activePatternResult = $007CPrefix$007C_$007C("/", str);
        if (activePatternResult != null) {
            const remains = activePatternResult;
            str_mut = remains;
            continue iframeUrlToHash;
        }
        else {
            return "#i/" + str;
        }
        break;
    }
}

function menuItemsToDomainType(menuItems) {
    const itemTypeToDomainType = (menuItem) => {
        const matchValue = menuItem.MenuItemType;
        if (matchValue == null) {
            return toFail(printf("itemTypeToDomainType menuItem.MenuItemType is None. Title: %s"))(menuItem.Title);
        }
        else {
            const itemType = matchValue;
            const matchValue_1 = itemType.PageType;
            switch (matchValue_1) {
                case "FablePage": {
                    return new SubItem(0, new MenuItem(menuItem.Title, map((url) => ("#" + url), menuItem.Url), map_1(itemTypeToDomainType, menuItem.SubItems)));
                }
                case "Link": {
                    return new SubItem(2, new MenuItem(menuItem.Title, itemType.ExternalUrl, map_1(itemTypeToDomainType, menuItem.SubItems)));
                }
                default: {
                    return new SubItem(1, new MenuItem(menuItem.Title, map(iframeUrlToHash, menuItem.Url), map_1(itemTypeToDomainType, menuItem.SubItems)));
                }
            }
        }
    };
    return map_1((menuItem_1) => {
        let matchValue_2, itemType_3, itemType_4;
        return new MenuItem(menuItem_1.Title, (matchValue_2 = menuItem_1.MenuItemType, (matchValue_2 != null) ? ((matchValue_2.PageType === "Link") ? ((itemType_3 = matchValue_2, itemType_3.ExternalUrl)) : ((matchValue_2.PageType === "Page") ? ((itemType_4 = matchValue_2, map(iframeUrlToHash, menuItem_1.Url))) : map((url_1) => ("#" + url_1), menuItem_1.Url))) : map((url_1) => ("#" + url_1), menuItem_1.Url)), map_1(itemTypeToDomainType, menuItem_1.SubItems));
    }, menuItems);
}

function sessionContextDTOToDomain(context) {
    return new SessionContext(context.AccountType, context.AvailableLanguages, context.ClientConfig, context.CurrentUserName, context.RequireIdsStepUp, context.IsAdminUser, menuItemsToDomainType(context.MenuItems), new RoleItem(sortBy((role) => role.RoleName, context.RoleItems.SelectableRoles, {
        Compare: compare,
    }), context.RoleItems.SelectedRole), context.SelectedLanguage, context.VersionBadgeUrl, context.CountryCode, context.LanguageCode, context.Privileges);
}

export function loadSessionContextThunk() {
    return createThunk((dispatch) => ((getState) => {
        if (LoadState_zip(getState().Model.GlobalDependencies, getState().Model.SessionContext).tag === 1) {
        }
        else {
            if (getState().Model.GlobalDependencies.tag === 2) {
            }
            else {
                dispatch(setGlobalDependencies(new LoadState$2(1)));
            }
            if (getState().Model.SessionContext.tag === 2) {
            }
            else {
                dispatch(setSessionContext(new LoadState$2(1)));
            }
            startImmediate(singleton.Delay(() => singleton.Bind(loadSessionContext(), (_arg) => {
                const result = _arg;
                if (result.tag === 0) {
                    const domainSessionContext = sessionContextDTOToDomain(result.fields[0]);
                    dispatch(setSessionContext(new LoadState$2(2, domainSessionContext)));
                    const matchValue_3 = domainSessionContext.ClientConfig;
                    if (matchValue_3 != null) {
                        dispatch(setGlobalDependencies(new LoadState$2(2, new GlobalDependencies(matchValue_3, defaultArg(domainSessionContext.RoleItems.SelectedRole.ClientNr, -1), domainSessionContext.RoleItems.SelectedRole.InvoiceeNr, optToStr(domainSessionContext.RoleItems.SelectedRole.RoleName), domainSessionContext.CountryCode, domainSessionContext.LanguageCode, domainSessionContext.CurrentUserName, domainSessionContext.RequireIdsStepUp, domainSessionContext.SelectedLanguage, domainSessionContext.IsAdminUser, domainSessionContext.Privileges))));
                        return singleton.Zero();
                    }
                    else {
                        logei("ClientConfig missing, probably clientNr not available in this environment.");
                        return singleton.Zero();
                    }
                }
                else {
                    const msg = result.fields[0];
                    logei(msg);
                    dispatch(setGlobalDependencies(new LoadState$2(3, msg)));
                    dispatch(setSessionContext(new LoadState$2(3, msg)));
                    return singleton.Zero();
                }
            })));
        }
    }));
}

